import { render } from "./MonthPicker.vue?vue&type=template&id=a590367a"
import script from "./MonthPicker.vue?vue&type=script&lang=ts"
export * from "./MonthPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script